/*
 * Copyright (c) 2008-2022 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

export const LICENSING_UPGRADE_REQUIRED = "license:upgradeRequired"

export const FEATURE_UNDER_DEVELOPMENT = "feature:underDevelopment"

export const USER_ACTION_PROCESSING_STARTED = "userAction:processingStarted"

export const USER_ACTION_PROCESSING_FINISHED = "userAction:processingFinished"

export const INTERACTION_RESET_FINISHED = "interaction:resetFinished"

export const TIPTAP_CUSTOMEMBED_ATTRIBUTE_CHANGED = "tiptap:customEmbed:attributeChanged"

export const TIPTAP_CUSTOMEMBED_DISPLAY_POSITIONED = "tiptap:customEmbed:displayPositioned"

export const TIPTAP_EXTERNAL_ADD_INTERACTION = "tiptap:externalComponent:addInteraction"

export const TIPTAP_EXTERNAL_EDIT_INTERACTION = "tiptap:externalComponent:editInteraction"

export const TOUR_OPEN_INTERACTION_EXPLAIN_MODAL = "tour:interactionExplainModal:open"

/**
 * Event emitted whenever the locally held set of "assigned" tenants is updated.
 * (see tenants.js store)
 *
 * @type {string}
 */
export const TENANTS_ASSIGNED_TENANTS_UPDATED = "tenants:assignedTenantsUpdated"

/**
 * Event emitted whenever the locally held set of license packages is updated.
 * (see licensing.js store)
 *
 * @type {string}
 */
export const LICENSING_PACKAGES_UPDATED = "licensing:packagesUpdated"

/**
 * Event emitted whenever the locally held set of license assignments is updated.
 * (see licensing.js store)
 *
 * @type {string}
 */
export const LICENSING_ASSIGNMENTS_UPDATED = "licensing:assignmentsUpdated"

/**
 * Event emitted whenever a single meeting got loaded and updated in the
 * locally held set of meetings. (see meetings.js store)
 *
 * @type {string}
 */
export const MEETING_LOADED = "meeting:loaded"

/**
 * Event emitted whenever multiple meeting got loaded and updated in the
 * locally held set of meetings.(see meetings.js store)
 *
 * @type {string}
 */
export const MEETINGS_LOADED = "meetings:loaded"

/**
 * Event emitted whenever a single meeting got created and updated in the
 * locally held set of meetings. (see meetings.js store)
 *
 * @type {string}
 */
export const MEETING_CREATED = "meeting:created"

/**
 * Event emitted whenever multiple meetings got created (via upload)
 * and updated in the locally held set of meetings. (see meetings.js store)
 *
 * @type {string}
 */
export const MEETINGS_CREATED = "meetings:created"

/**
 * Event emitted whenever permissions of logged in user for every meeting
 * got loaded and updated in the locally held set of meetingPermissions.
 * (see auth.js store)
 *
 * @type {string}
 */
export const MEETING_PERMISSIONS_LOADED = "meeting:permissions:loaded"
